import { List, Record } from 'immutable'
import { FeedItemToken, IFeedItemToken } from './FeedItemToken'

export interface IMentionEditorSuggestions {
  readonly error?: string
  readonly isFetching: boolean
  readonly searchFilter?: string
  readonly suggestions: List<FeedItemToken>
}

const MentionEditorSuggestionsRecord = Record({
  error: undefined,
  isFetching: false,
  searchFilter: undefined,
  suggestions: List<FeedItemToken>(),
})

export class MentionEditorSuggestions extends MentionEditorSuggestionsRecord
  implements IMentionEditorSuggestions {
  public static fromJS(initialState?: Partial<IMentionEditorSuggestions>) {
    return new MentionEditorSuggestions(initialState)
  }

  public readonly error?: string
  public readonly isFetching: boolean
  public readonly searchFilter?: string
  public readonly suggestions: List<FeedItemToken>

  constructor(props?: Partial<MentionEditorSuggestions>) {
    props ? super(props) : super()
  }
}
